import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { plansAPI, Plan } from "@/lib/api";

export const usePlans = () => {
  return useQuery({
    queryKey: ['plans'],
    queryFn: async () => {
      const response = await plansAPI.getAllPlans();
      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const usePlan = (planId: string | null) => {
  return useQuery({
    queryKey: ['plan', planId],
    queryFn: async () => {
      if (!planId) return null;
      const response = await plansAPI.getPlanById(planId);
      return response.data;
    },
    enabled: !!planId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useGeneratePlan = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { language: string; expertise: string }) => {
      const response = await plansAPI.generatePlan(data);
      return response.data;
    },
    onSuccess: () => {
      // Invalidate plans query to refetch the list
      queryClient.invalidateQueries({ queryKey: ['plans'] });
    },
  });
};
